<template>
  <div class="ma-0 ma-sm-4">
    <v-card class="blueCard" flat>
      <v-card-title
        ><v-img
          contain
          max-width="40"
          class="mr-4"
          src="https://www.eyedock.com/images/menu_icons/plaquenil_icon.svg"
        ></v-img
        >Plaquenil Risk Calculations</v-card-title
      >
    </v-card>

    <v-container class="mt-8 mx-0 pa-0">
      <v-row
        ><v-col order="last" order-md="first"
          ><page
            articleSlug="plaquenil-calcs-discussion"
            :showHeader="false"
          ></page> </v-col
        ><v-col order="first" order-md="last">
          <plaquenil-weight-calc class="mt-2 mb-8"></plaquenil-weight-calc>
          <plaquenil-cumulative-calc class="mb-8"></plaquenil-cumulative-calc>
          <!-- see also stuff-->
          <v-card flat color="#fffbf1" class="pa-4 brownBorder">
            <div class="overline">Related Resources</div>
            <v-list dense style="background-color: transparent">
              <v-list-item-group>
                <v-subheader>
                  Ocular Conditions

                  <span v-if="!isSubscribed" class="red--text mx-1 caption">
                    (Requires EyeDock PRO)</span
                  ></v-subheader
                >
                <v-list-item
                  to="/ocular-conditions/details/plaquenil-maculopathy"
                >
                  <v-list-item-icon>
                    <div style="width: 70px">
                      <v-img
                        contain
                        height="30"
                        max-width="60"
                        src="https://eyedock.com/images/ocular_conditions/Plaquenil-Maculopathy.png"
                      ></v-img>
                    </div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Plaquenil Maculopathy</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </v-list-item-group>
              <v-list-item-group>
                <v-subheader> ICD10 Codes</v-subheader>
                <v-list-item to="/icd10/Z79.89">
                  <v-list-item-icon>
                    <div style="width: 70px">Z79.8</div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      >Other long term (current) drug therapy</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item to="/icd10/H35.38">
                  <v-list-item-icon>
                    <div style="width: 70px">H35.38</div>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Toxic maculopathy</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
          <!-- /see also stuff-->
        </v-col>
      </v-row>
    </v-container>
    <see-also
      class="pt-6"
      style="max-width: 400px"
      referrer="SITE"
      :identifier="['Z79.89', 'H25.38']"
    ></see-also>
  </div>
</template>

<script>
import PlaquenilCumulativeCalc from "./PlaquenilCumulativeCalc.vue";
import PlaquenilWeightCalc from "./PlaquenilWeightCalc.vue";
import Page from "@/components/pagesStuff/Page";
import UserMixin from "@/assets/js/UserMixin";
import SeeAlso from "@/components/universalStuff/SeeAlso.vue";

export default {
  name: "Plaquenil",
  components: { PlaquenilCumulativeCalc, PlaquenilWeightCalc, Page, SeeAlso },
  mixins: [UserMixin],
  props: {},
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style scoped>
.brownBorder {
  border: 1px solid #a79e89 !important;
  border-radius: 5px;
  background-color: #fff;
}
</style>
